/**
 * Path constants
 *
 * Developed By : Travancore Analytics (2025)
 * Author: Akhil Soman
 * Created on: 28/02/2025
 * Project: Vitromed
 * Revision History:
 * SNo.   | Date        | Author        | Task                | Comments |
 * 1      28/02/2025    Akhil Soman       Creating new File
 */

const RoutePath = {
  home: "/",
  knowledgehub: "/knowledgehub",
  assessmentQuestion: "/assessments",
  assessmentQuestions: "/assessment/start",
  assessmentSummary: "/assessment-summary",
  questionForm: "/questions",
  topic: "/topics",
  assessmentForm: "/assessment-form",
  userManagement: "/user-management",
  assets: "/assets",
  assetCategory: "/asset-category",
  otp: "/otp",
  myAccount: "/my-account",
};

export default RoutePath;
